<template>
  <div class="organization-page-template">
    <app-layout>
      <div class="container" v-if="!isLoadingOrganization">
        <div v-if="!isError">
          <div class="org-tabs">
            <div
              class="org-tab"
              :class="currentTab === 'home' ? 'active-tab' : ''"
              @click="changeTab('home')"
            >Home</div>
            <div
              class="org-tab"
              :class="currentTab === 'post' ? 'active-tab' : ''"
              @click="changeTab('post')"
            >Posts</div>
            <!-- <div
              class="org-tab"
              :class="currentTab === 'gallery' ? 'active-tab' : ''"
              @click="changeTab('gallery')"
            >Gallery</div> -->
            <div
              class="org-tab"
              :class="currentTab === 'more' ? 'active-tab' : ''"
              @click="changeTab('more')"
            >
              Info
              <!-- <i class="fa fa-ellipsis-v" /> -->
            </div>
          </div>
          <div v-if="currentTab == 'home'">
            <div class="organization-banner">
              <img draggable="false" :src="organizationCover" alt="org-cover" />
            </div>
            <div class="org-info">
              <div class="org-avatar">
                <div class="org-avatar-wrapper">
                  <img :src="organizationAvatar" draggable="false" alt="org-avatar" />
                </div>
              </div>
              <div class="org-name-wrapper">{{organization.title}}</div>
            </div>
            <!-- <Button type="info" style="margin: 20px 20px 0 20px;">CHAT</Button> -->
            <div class="org-controls">
              <div
                @click="followUnfollow"
                class="org-control-buttons"
                :class="[isFollowed ? 'active-color': '', isLoadingFollow ? 'disabled' : '']"
              >
                <span v-if="isLoadingFollow" class="loader">
                  <Icon type="load-c" />
                </span>
                <div class="follow" v-else>
                  <Icon type="checkmark" size="30" />
                  <span>{{ isFollowed ? 'Followed' : 'Follow'}}</span>
                </div>
              </div>
              <div class="org-control-buttons" @click="showInvite = true">
                <Icon type="share" size="30" />
                <span>Share</span>
              </div>
              <div
                class="org-control-buttons"
                :class="[isBookmarked ? 'active-color': '', isBookmarkLoading ? 'disabled' : '']"
                @click="onSetBookmark"
              >
                <span v-if="isBookmarkLoading" class="loader">
                  <Icon type="load-c" />
                </span>
                <div class="follow" v-else>
                  <Icon type="bookmark" size="30" />
                  <span>{{ isBookmarked ? 'Unbookmark' : 'Bookmark'}}</span>
                </div>
              </div>
            </div>
            <div class="org-social">
              <div @click="openLink(fbUrl)" class="org-social-buttons" :class="!fbUrl ? 'disabled' : ''">
                <a target="_blank">
                  <Icon type="social-facebook" size="32"></Icon>
                </a>
              </div>
              <div @click="openLink(twitterUrl)" class="org-social-buttons" :class="!twitterUrl ? 'disabled' : ''">
                <a target="_blank">
                  <Icon type="social-twitter" size="32"></Icon>
                </a>
              </div>
              <div @click="openLink(instagramUrl)" class="org-social-buttons" :class="!instagramUrl ? 'disabled' : ''">
                <a target="_blank">
                  <Icon type="social-instagram" size="32"></Icon>
                </a>
              </div>
              <div @click="openLink(linkedInUrl)" class="org-social-buttons" :class="!linkedInUrl ? 'disabled' : ''">
                <a target="_blank">
                  <Icon type="social-linkedin" size="32"></Icon>
                </a>
              </div>
              <div @click="openLink(websiteUrl)" class="org-social-buttons" :class="!websiteUrl ? 'disabled' : ''">
                <a target="_blank">
                  <Icon type="android-globe" size="32"></Icon>
                </a>
              </div>
              <div @click="openMobile" class="org-social-buttons" :class="!contactNumber ? 'disabled' : ''">
                <a>
                  <Icon type="ios-telephone" size="32"></Icon>
                </a>
              </div>
              <div @click="openEmail" class="org-social-buttons" :class="!emailAddress ? 'disabled' : ''">
                <a>
                  <Icon type="email" size="32"></Icon>
                </a>
              </div>
            </div>
          </div>
          <div class="tab-panel">
            <div class="tab" style="padding: 0 40px;" v-show="currentTab === 'home'">
              <Row :gutter="20">
                <Col :span="isCheckIn && isShowDonate ? 12 : 24">
                  <Button v-show="isCheckIn" @click="showCheckIn()" long type="info">CHECK-IN</Button>
                </Col>
                <Col :span="isShowDonate && isCheckIn ? 12 : 24">
                  <Button v-show="isShowDonate" long type="warning" @click="donate">DONATE</Button>
                </Col>
                <Col :span="24" style="margin-top:10px">
                  <Button
                    long
                    v-show="isShowAddToCareTeam"
                    :type="isAddedToCareTeam ? 'error' : 'info'"
                    :loading="isAddToCareteamLoading"
                    @click="careteam"
                  >{{ isAddedToCareTeam ? 'REMOVE FROM MY CARE TEAM' : 'ADD TO MY CARE TEAM' }}</Button>
                </Col>
              </Row>
            </div>
            <div class="tab" v-show="currentTab === 'post'">
              <PostActivity
                v-if="checkIfUserCanPost(organization) && isFollowed && profileInfo.user_type !== 'guest'"
                view="organization"
                :page-data="organization"
              />
              <FeedListComponent section="organization" :isAdmin="false" :isModeration="false" />
            </div>
            <div class="tab" v-show="false && currentTab === 'gallery'">
              <div v-if="!gallery.isLoading">
                <div class="gallery-item-wrapper" v-if="gallery.data && gallery.data.length > 0">
                  <Card
                    v-for="(galleryItem, i) in gallery.data"
                    :key="i"
                    @click="openPost(galleryItem.id)"
                    class="gallery-item pointer">
                    <img :src="galleryItem.thumbnail_photo[0].small" alt="">
                  </Card>
                </div>
                <div v-else class="empty-gallery">
                  <p>No images</p>
                </div>
              </div>
              <div v-else style="padding:10px;text-align:center;color:#aaa">
                <Icon type="load-c" style="animation: ani-demo-spin 1s linear infinite;" />
              </div>
            </div>
            <div class="tab" v-show="currentTab === 'more'">
              <GroupInfoPageUI :pages="organization.pages || []"/>
              <div class="more" v-if="brand && brand.about_me">
                <h4>About {{organization.title}}</h4>
                <small>
                  <p>{{brand.about_me}}</p>
                </small>
              </div>
              <div style="margin-top: 8px;" class="more">
                <div class="more-info-links">
                  <div style="width: 14px; margin-right: 10px">
                    <Icon type="android-globe" size="18"></Icon>
                  </div>
                  <a v-if="websiteUrl" :href="websiteUrl" target="_blank">{{websiteUrl}}</a>
                  <small v-else>No website url available</small>
                </div>
                <div class="more-info-links">
                  <div style="width: 14px; margin-right: 10px">
                    <Icon type="ios-telephone" l size="18"></Icon>
                  </div>
                  <a v-if="contactNumber" @click="openMobile">{{contactNumber}}</a>
                  <small v-else>No contact number available</small>
                </div>
                <div class="more-info-links">
                  <div style="width: 14px; margin-right: 10px">
                    <Icon type="navigate" size="18"></Icon>
                  </div>
                  <p v-if="address">
                    {{ address }}
                  </p>
                  <small v-else>No address available</small>
                </div>
              </div>
              <div v-if="address" style="margin-top: 8px;" class="more">
                <div class="map">
                  <div ref="orgMap"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="org-bot-controls">
            <img alt=" " src="@/assets/end-comment.png" width="80px" height="40px" style="margin-top:-5px">
              <span @click="goBack()">
                <Avatar class="action-back pointer" style="background: white;" :src="require('@/assets/back.png')" />
              </span>
          </div>
        </div>
        <div v-else class="error-wrapper">
          <!-- <Icon type="sad-outline" size="32"></Icon> -->
          <h3 class="error-text">Unable to load organization</h3>
        </div>
      </div>
    </app-layout>

    <Modal
      v-model="checkin.show"
      class="checkInModal"
      :title="`Share ${organization.title}`"
      :closable="false"
      :scrollable="true"
      :transfer="true"
      :mask-closable="false"
      @on-visible-change="onCheckinVisibleChange"
    >
      <div
        slot="header"
        class="flex-container direction-row center"
        style="justify-content:space-between;"
      >
        <div class="order-1"></div>
        <b class="order-2">You checked in to {{organization.title}}</b>
        <div class="order-3"></div>
        <img
          alt=" "
          @click="checkin.show=false"
          style="height:25px; width:25px;position:absolute;top:0;right:0;margin:10px 10px 0 0;"
          src="@/assets/close.png"
        />
      </div>
      <div v-if="checkin.show" style="height:100%;overflow:visible;overflow-y:visible">
        <i-input v-model="checkin.note" type="textarea" :rows="4" placeholder="Write a note"></i-input>
      </div>
      <div slot="footer">
        <Button type="text" :loading="checkin.isLoadingSkip" @click="checkIn('skip')">Skip</Button>
        <Button type="primary" :loading="checkin.isLoadingPost" @click="checkIn()">Post</Button>
      </div>
    </Modal>

    <Modal
      v-model="showInvite"
      class="shareModal"
      :title="`Share ${organization.title}`"
      :closable="false"
      :scrollable="true"
      :transfer="true"
      :mask-closable="false"
      @on-visible-change="onInviteVisibleChange"
    >
      <div
        slot="header"
        class="flex-container direction-row center"
        style="justify-content:space-between;"
      >
        <div class="order-1"></div>
        <b class="order-2">Share organization</b>
        <div class="order-3"></div>
        <!-- <img
          alt=" "
          @click="showInvite=false"
          style="height:25px; width:25px;position:absolute;top:0;right:0;margin:10px 10px 0 0;"
          src="@/assets/close.png"
        /> -->
      </div>
      <div v-if="showInvite" style="height:100%;overflow:visible;overflow-y:visible">
        <share-component
          @invitationSent="showInvite = false"
          shareType="sms"
          :brandId="brandInfo.id"
          :prescriberId="organization.developed_by"
          ref="shareComponent"
        ></share-component>
      </div>
      <div slot="footer">
        <Button type="text" @click="showInvite = false">Close</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import * as API from "@/endpoints";
import ShareComponent from "@/views/ShareComponent";
import FeedListComponent from "@/components/FeedListComponent";
import PostActivity from "@/components/PostActivityComponent";
import GroupInfoPageUI from "@/components/GroupInfoPageUI";
import { Message } from "iview";
import { setTimeout } from "timers";
import _ from "lodash";
import { mapGetters } from 'vuex';

export default {
  name: "OrganizationComponent",
  components: {
    ShareComponent,
    FeedListComponent,
    PostActivity,
    GroupInfoPageUI
  },
  data() {
    return {
      isLoadingOrganization: false,
      isError: false,
      showInvite: false,
      isLoadingFollow: false,
      isBookmarkLoading: false,
      checkin: {
        isLoadingSkip: false,
        isLoadingPost: false,
        show: false,
        note: ""
      },
      isAddToCareteamLoading: false,
      gallery: {
        isLoading: false,
        data: {}
      }
    };
  },
  mounted() {
    // if (
    //   !this.$store.state.org.organization.careplan_id ||
    //   this.organizationId !== this.$store.state.org.organization.careplan_id
    // ) {
    this.loadOrganization();
    // }
    if (!this.currentTab) this.changeTab("home");
  },
  watch: {
    organizationId(n, o) {
      if (n !== o) this.loadOrganization();
    }
  },
  computed: {
    ...mapGetters("user", ["brandInfo"]),
    brand() {
      return this.$store.state.org.organization.brand;
    },
    organization() {
      return this.$store.state.org.organization.info;
    },
    showSuccess: {
      get() {
        return this.$store.state.share.showSuccess;
      }
    },
    profileInfo: {
      get() {
        return this.$store.state.user.info;
      }
    },
    address() {
      let address = _.get(this.brand, "address", "")
      let city = _.get(this.brand, "city", "")
      let zipcode = _.get(this.brand, "zipcode", "")
      let country = _.get(this.brand, "country", "")
  
      let r = address ? address + ", " : r
      r = city ? r + city + " " : r
      r = zipcode ? r + zipcode + " " : r
      r = country ? r + country : r

      return r && r.trim() ? r : false
    },
    fbUrl() {
      if( this.brand && this.brand.organization_link && this.brand.organization_link.facebook )
        return this.brand.organization_link.facebook;
      return null;
    },
    instagramUrl() {
      if( this.brand && this.brand.organization_link && this.brand.organization_link.instagram )
        return this.brand.organization_link.instagram;
      return null;
    },
    twitterUrl() {
      if( this.brand && this.brand.organization_link && this.brand.organization_link.twitter )
        return this.brand.organization_link.twitter;
      return null;
    },
    linkedInUrl() {
      if( this.brand && this.brand.organization_link && this.brand.organization_link.linkedin )
        return this.brand.organization_link.linkedin;
      return null;
    },
    websiteUrl() {
      if( this.brand && this.brand.organization_link && this.brand.organization_link.website )
        if (this.brand.organization_link.website.includes("@rand0m"))
          return null
        else
          return this.brand.organization_link.website;
      return null;
    },
    contactNumber() {
      return _.get(this.brand, "contact_number", "")
    },
    emailAddress() {
      return _.get(this.brand, "email", "").includes("@rand0m") ? null : _.get(this.brand, "email", "");
    },
    organizationAvatar() {
      return this.organization
        ? this.organization.thumbnail_photo
          ? this.organization.thumbnail_photo[0].medium
          : ""
        : "";
    },
    actionButtons() {
      if( !this.brand || !this.brand.data )
        return {}
      return this.brand.data
    },
    isShowDonate() {
      return (this.actionButtons && this.actionButtons.donate ) ? this.actionButtons.donate : false;
    },
    isCheckIn() {
      return (this.actionButtons && this.actionButtons.checkIn ) ? this.actionButtons.checkIn : false;
    },
    isShowAddToCareTeam() {
      return (this.actionButtons && this.actionButtons.addToCareTeam ) ? this.actionButtons.addToCareTeam : false;
    },
    organizationCover() {
      var cover = this.brand
        ? this.brand.theme
          ? this.brand.theme.organization_cover_photo
          : ""
        : "";

      if (!cover || cover.includes("module-default"))
        return require("@/assets/org-banner.jpg");
      else
        return (
          process.env.VUE_APP_SERVICE_WORKER_S3 +
          cover.substring(1, cover.length)
        );
    },
    organizationId() {
      return this.$route.params.orgId;
    },
    currentTab() {
      return this.$route.query.t;
    },
    isBookmarked: {
      get() {
        return this.brand.is_bookmarked;
      },
      set(v) {
        this.$store.state.org.organization.brand.is_bookmarked = v;
      }
    },
    isFollowed: {
      get() {
        return this.brand.is_followed;
      },
      set(v) {
        this.$store.state.org.organization.brand.is_followed = v;
      }
    },
    isAddedToCareTeam: {
      get() {
        // return false
        return this.brand.is_on_your_careteam;
      },
      set(v) {
        this.brand.is_on_your_careteam = v;
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("org/clearOrganization");
    next();
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    openLink(url) {
      if (!url) return
      var win = window.open(url, '_blank');
      win.focus();
    },
    showCheckIn() {
      if (this.profileInfo.user_type === 'guest') {
        this.$store.commit('hitCheckpoint')
        return false
      }

      this.checkin.show = true
    },
    openPost(id) {
      this.$router.push('/feed/' + this.id)
    },
    loadOrganizationGallery() {
      this.gallery.isLoading = true;
      this.$store
        .dispatch("org/getOrganizationGallery")
        .then(res => {
          this.gallery.data = res
        })
        .finally(() => {
          this.gallery.isLoading = false;
        });
    },
    donate() {
      if (this.profileInfo.user_type === 'guest') {
        this.$store.commit('hitCheckpoint')
        return false
      }

      console.log(this.brand);
      this.$router.push("/donate?isOrganization=1&organization="+this.organization.developed_by+"&rid=" + this.brand.group.id);
    },
    checkIn(v) {
      let item = Cons[0].ACTIVITY;

      let params = {
        data_type: "content",
        day: 0,
        title: `${this.profileInfo.display_name} checked in to ${this.organization.title}`,
        type: "check_in"
      };
      item = { ...item, ...params };
      item.data.text = v ? "" : this.checkin.note;

      this.checkin[v ? "isLoadingSkip" : "isLoadingPost"] = true;
      this.$store
        .dispatch("feed/postCareplanUpdate", {
          id: this.profileInfo.private_careplan_id,
          data: item
        })
        .then(res => {
          Message.info("Checked in!");
          this.onCheckinVisibleChange(false);
        })
        .catch(err => {
          Message.error("Something went wrong!");
          this.onCheckinVisibleChange(false);
        });
    },
    careteam() {
      // this.$Message({
      //   closable: true,
      //   title: { content: "Add to my careteam" },
      //   message: { content: "This feature is coming soon" }
      // });
      // return

      if (this.profileInfo.user_type === "guest") {
        this.$store.commit("hitCheckpoint");
        return;
      }

      if (this.isAddedToCareTeam) this.removeFromCareteam();
      else this.addToCareteam();
    },
    addToCareteam() {
      this.isAddToCareteamLoading = true;
      this.$store
        .dispatch("org/addToCareteam", this.brand.id)
        .then(res => {
          this.brand.journal_careplan_id = res.id;
          this.isAddedToCareTeam = true;
        })
        .finally(() => {
          this.isAddToCareteamLoading = false;
        });
    },
    removeFromCareteam() {
      this.isAddToCareteamLoading = true;
      this.$store
        .dispatch("org/removeFromCareteam", this.brand.journal_careplan_id)
        .then(res => {

          this.brand.journal_careplan_id = null;
          this.isAddedToCareTeam = false;
        })
        .finally(() => {
          this.isAddToCareteamLoading = false;
        });
    },
    openEmail() {
      if (!this.emailAddress) return

      this.$Message({
        closable: true,
        title: { content: "Email address" },
        icon: "email",
        message: { content: this.emailAddress },
        buttons: [
          { 
            label: 'Close', 
            hideAfter: true, 
            action: ()=> {}
          },
          { 
            label: 'Ok', 
            type: 'primary', 
            hideAfter: true, 
            action: ()=> {
              if (this.$store.state.isMobile) {
                var dialerWindow = window.open("mailto:" + this.emailAddress);
                dialerWindow.close();
              } else {
                window.location.href = `mailto:${this.emailAddress}`
              }
            }
          }
        ]
      });
    },
    openMobile() {
      if (!this.contactNumber) return
      
      this.$Message({
        closable: true,
        title: { content: "Contact Number" },
        icon: "ios-telephone",
        message: { content: this.contactNumber },
        buttons: [
          { 
            label: 'Close', 
            hideAfter: true, 
            action: ()=> {}
          },
          {
            label: "Ok",
            type: "primary",
            hideAfter: true,
            action: () => {
              if (this.$store.state.isMobile) {
                var dialerWindow = window.open("tel:" + this.contactNumber);
                dialerWindow.close();
              } else {
                window.location.href = `tel:${this.contactNumber}`
              }
            }
          }
        ]
      });
    },
    checkIfUserCanPost(data) {
      if (!data) return;
      if (data.members_can_post) {
        return true;
      } else {
        if (
          data.permission &&
          "permission" in data.permission &&
          data.permission.permission == 0
        )
          return true;
        if (
          data.permission &&
          "permission" in data.permission &&
          data.permission.permission == 511
        )
          return true;
        if (
          data.permission &&
          "permission" in data.permission &&
          data.permission.permission == 503
        )
          return true;
        if (
          data.permission &&
          "permission" in data.permission &&
          data.permission.permission == 16
        )
          return true;
        if (
          data.permission &&
          "permission" in data.permission &&
          data.permission.permission == 49
        )
          return true;
      }

      return false;
    },
    onSetBookmark() {
      if (this.profileInfo.user_type === "guest") {
        this.$store.commit("hitCheckpoint");
      } else {
        // this.$Message({
        //   closable: true,
        //   title: { content: "Bookmark" },
        //   message: { content: "This feature is coming soon" }
        // });
        this.isBookmarkLoading = true;

        if (this.isBookmarked) {
          this.$store
            .dispatch("org/removeBookmark", this.brand.bookmark_id)
            .then(res => {
              this.isBookmarked = false;
              this.$store.state.org.organization.brand.bookmark_id = null;
              this.isBookmarkLoading = false;
            })
            .catch(err => {
              this.isBookmarkLoading = false;
            });
        } else {
          this.$store
            .dispatch("org/bookmark", this.brand.id)
            .then(res => {
              this.isBookmarked = true;
              this.$store.state.org.organization.brand.bookmark_id = res.id;
              this.isBookmarkLoading = false;
            })
            .catch(err => {
              this.isBookmarkLoading = false;
            });
        }
      }
    },
    followUnfollow() {
      if (this.profileInfo.user_type === "guest") {
        this.$store.commit("hitCheckpoint");
        return;
      }
      if (this.isLoadingFollow) return;
      if (this.isFollowed) {
        this.isLoadingFollow = true;
        this.$store
          .dispatch("publicProfile/unfollowUser", { userId: this.brand.id })
          .then(res => {
            this.isFollowed = false;
            this.isLoadingFollow = false;
          })
          .catch(err => {
            this.isLoadingFollow = false;
          });
      } else {
        this.isLoadingFollow = true;
        this.$store
          .dispatch("publicProfile/followUser", { userId: this.brand.id })
          .then(res => {
            this.isFollowed = true;
            this.isLoadingFollow = false;
          })
          .catch(err => {
            this.isLoadingFollow = false;
          });
      }
    },
    loadMap() {
      this.$nextTick(() => {
        var latlng = new google.maps.LatLng(39.305, -76.617);
        var geoCoder = new google.maps.Geocoder();

        var map = new google.maps.Map(this.$refs.orgMap, {
          center: latlng,
          zoom: 12,
          mapTypeControl: false,
          scaleControl: false,
          scrollwheel: false,
          navigationControl: false,
          streetViewControl: false
        });

        geoCoder.geocode(
          {
            address: this.address + "" || "10001"
          },
          (res, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
              map.setCenter(res[0].geometry.location);
              new google.maps.Marker({
                map: map,
                position: res[0].geometry.location
              });
            } else {
              this.$notice.error("Unable to find organization location.");
            }
          }
        );
      });
    },
    onInviteVisibleChange(isVisible) {
      if (isVisible) {
        if (this.showSuccess) {
          this.$store.commit("share/setShowSuccess", false);
        }
      } else {
        this.$refs.shareComponent.resetFields();
      }
    },
    onCheckinVisibleChange(isVisible) {
      if (!isVisible) {
        this.checkin = {
          isLoadingSkip: false,
          isLoadingPost: false,
          show: false,
          note: ""
        };
      }
    },
    loadBrand() {
      this.isLoadingOrganization = true;
      this.isError = false;
      this.$store.commit("base/setLoadingPage", true, { root: 1 });
      this.$store
        .dispatch("org/getOrganizationBrand", this.organization.developed_by)
        .then(res => {
          this.isLoadingOrganization = false;
          this.isError = false;
          this.$store.commit("base/setLoadingPage", false, { root: 1 });
          if (this.address) this.loadMap();
          this.loadOrganizationItems();
          this.loadOrganizationGallery();
        })
        .catch(err => {
          this.isLoadingOrganization = false;
          this.isError = true;
          this.$store.commit("base/setLoadingPage", false, { root: 1 });
        });
    },
    loadOrganizationItems() {
      this.$store.dispatch("org/getOrganizationItems");
    },
    loadOrganization() {
      this.isLoadingOrganization = true;
      this.isError = false;
      this.$store.commit("base/setLoadingPage", true, { root: 1 });
      this.$store
        .dispatch("org/getOrganizationInfo", this.organizationId)
        .then(res => {
          this.$router.replace({
            query: {
              ...this.$route.query,
              title: this.organization.title
            }
          });

          this.isLoadingOrganization = false;
          this.isError = false;
          this.$store.commit("base/setLoadingPage", false, { root: 1 });
          this.loadBrand();
        })
        .catch(err => {
          this.isLoadingOrganization = false;
          this.isError = true;
          this.$store.commit("base/setLoadingPage", false, { root: 1 });
        });
    },
    changeTab(tab) {
      this.$router.replace({
        name: this.$route.name,
        params: { orgId: this.organizationId },
        query: {
          t: tab,
          title: this.organization.title
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.org-bot-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 25px 0;
  img {
    margin-bottom: 8px;
  }
}
.empty-gallery {
  padding: 10px;
  color: #aaa;
  // background: white;
  height: 60px;
  line-height: 40px;
  text-align: center;
  width: 100%;
}

.gallery-item-wrapper {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.gallery-item {
  background: #aeaeae;
  width: 25%;
  height: 80px;
  display: flex;
  // margin: 4px;
}

.more {
  .map {
    div {
      height: 40vh;
    }
  }
}
.more-info-links {
  display: flex;
  align-items: center;
}

.tab {
  .coming-soon {
    height: 20vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .more {
    background: #ffffff;
    padding: 10px;
  }
}

.tab-panel {
  margin-top: 8px;
}

.active-tab {
  color: var(--link-color);
  background: #fff;
}

.active-color {
  color: var(--link-color);
}

.error-text {
  text-align: center;
  width: 100%;
  margin-top: 8px;
}

.error-wrapper {
  display: flex;
  height: 80vh;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.org-tabs {
  width: 100%;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #dddd;
  justify-content: space-around;
  background: #f1f1f1;
}

.org-tab:first-child {
  border-right: 1px solid #ddd;
}

.org-tab:nth-child(2) {
  border-right: 1px solid #ddd;
}

.org-tab:last-child {
  border-left: 1px solid #ddd;
}

.org-tab {
  line-height: 32px;
  cursor: pointer;
  width: calc(100% / 3);
  text-align: center;
  padding: 10px;
  svg {
    width: unset;
  }
}
.org-control-buttons {
  display: flex;
  flex-direction: column;
  width: fit-content;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  .follow {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .loader {
    display: flex;
    justify-content: center;
    i {
      animation: ani-demo-spin 1s linear infinite;
    }
  }
}

.org-control-buttons.disabled {
  cursor: default;
}

.org-social-buttons {
  display: flex;
  flex-direction: column;
  width: fit-content;
  align-items: center;
  width: 40px;
  height: 40px;
  border: 1px solid var(--primary-color);
  border-radius: 25%;
  cursor: pointer;
  justify-content: center;
  i {
    color: var(--primary-color);
  }
}

.org-social-buttons.disabled {
  cursor: not-allowed !important;
  border: 1px solid #b5b5b5;
  i {
    color: #b5b5b5;
  }
  i::before {
    cursor: not-allowed !important;
  }
}

.org-social {
  width: 100%;
  padding: 15px;
  margin: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.org-controls {
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  border-style: none none solid none;
  border-width: 0.8px;
  border-color: #dadada;
}
.organization-banner {
  height: 200px;
  background: #656565;
  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
}
.container {
  display: flex;
  flex-direction: column;
}
.org-info {
  display: flex;
}
.org-avatar-wrapper {
  height: 100px;
  width: 100px;
  background: #888888;
  box-shadow: 0px 1.5px 6px 2px #888888;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.org-avatar {
  margin: -60px 10px 0px 20px;
}
.org-name-wrapper {
  margin-top: 8px;
  font-size: 18px;
  font-weight: 600;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
